export const getEpisodeLabel = (typeLabel: string, numberInSequence?: number | null) =>
    numberInSequence ? `${typeLabel} #${numberInSequence}` : typeLabel;

export const getEpisodeNotesLabel = (typeLabel: string) => `${typeLabel} Notes`;

export const getEpisodeNotesHeadline = (typeLabel: string) =>
    `Notes about the current ${typeLabel.toLowerCase()}`;

export const getEpisodeNotesDescription = (typeLabel: string) =>
    `These notes will be visible to clinicians who are assigned to visits in this ${typeLabel.toLowerCase()}.`;
